import { Divider } from '@mui/material'
import {
  useBlockedUsers,
  useSearchBlockedUsers,
} from '$logic/user-policy/react-hook'
import { MenuIcon } from '$common/icons/menu'
import { AddUserIcon } from '$common/icons'
import { UserListItem, UserListItemSkeleton } from '$common/user-list-item'
import { EmptyStateList } from '$common/empty-state-list'
import { withSearchableListPage } from '$common/searchable-list-page'
import {
  closeBlockedUsers,
  openBlockUser,
  openUserProfile,
} from '$logic/router'
import { showRemoveBlockedUsersMenu } from '$comp/modals/menus/remove-blocked-users-menu'
import { t } from '$i18n'

function ListItem({ id }: { id: string }) {
  return (
    <>
      <UserListItem
        userId={id}
        hasDivider={false}
        onClick={() => openUserProfile(id)}
        SecondaryActionIcon={MenuIcon}
        onSecondaryActionIconClick={() =>
          showRemoveBlockedUsersMenu({ userId: id })
        }
      />
      <Divider variant="inset" />
    </>
  )
}

const Page = withSearchableListPage<
  { id: string },
  void,
  { query: string; fetchedItems: { id: string }[] }
>({
  appBarTitle: t('settings.sections.privacy.blockedUsers'),
  ListItem,
  SkeletonItem: UserListItemSkeleton,
  EmptyStateComponent: () => <EmptyStateList />,
  fetchHook: useBlockedUsers,
  searchHook: useSearchBlockedUsers,
  actionButtons: [
    {
      text: t('myAccount.blockedUsers.block'),
      icon: <AddUserIcon sx={{ color: 'secondary500' }} />,
      onClick: openBlockUser,
    },
  ],
  onBack: closeBlockedUsers,
})

export function BlockedUsers() {
  return (
    <Page
      fetchHookParams={undefined}
      getSearchHookParams={(query, fetchedItems) => ({ query, fetchedItems })}
    />
  )
}
